/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type AvailableForSelectedDatesEnum =
  (typeof AvailableForSelectedDatesEnum)[keyof typeof AvailableForSelectedDatesEnum];

export const AvailableForSelectedDatesEnum = {
  available: 'available',
  unavailable: 'unavailable',
  unknown: 'unknown',
} as const;
